export default "__VITE_ASSET__0cc88716__"